<auto-main-navigation [accountId]="accountId"></auto-main-navigation>
<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">MPOP Settings</h1>
  </p-header>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3">
      <p-panelMenu [model]="settingsSideNav">
      </p-panelMenu>
    </div>
    <p-panel class="p-col ad-types-wrapper">
      <p-header class="ad-types-header-wrapper">
        <h2 class="ad-types-header-text">Ad Types</h2>
      </p-header>
      <p-panel class="ad-types-form-panel">
        <p-header class="ad-types-header-wrapper form-panel-header">
          <h3 class="ad-types-header-text">Vehicle Ads</h3>
          <div class="ad-types-header-input">
            <div class="ad-types-header-input">
              <p-toggleswitch [ngModel]="accountAdTypes !== null && accountAdTypes.vehicleAdType.enabled" (ngModelChange)="accountAdTypes !== null && (accountAdTypes.vehicleAdType.enabled = $event)"
                (onChange)="handleVehicleAdsEnabledToggle()">
              </p-toggleswitch>
            </div>
          </div>
        </p-header>
        <!--        TODO: this should use an async pipe instead of null to determine when vehicle ads is enabled (same above for switch)-->
        @if (accountAdTypes !== null && accountAdTypes.vehicleAdType.enabled) {
          <div class="form-body-wrapper">
            @if (businessCategoryConfigurations !== null) {
              <form [formGroup]="masterFormGroup" autoTrackUnsavedChanges
                >
                <div class="ad-types-save-button">
                  <span [pTooltip]="getDisabledToolTip()"
                    tooltipPosition="top">
                    <button pButton
                      id="vehicleAdSaveButton"
                      class="p-button-success"
                      label="Save"
                      (click)="handleVehicleAdsSave()"
                      [disabled]="isSaveDisabled">
                    </button>
                  </span>
                </div>
                <p-tabs [value]="0">
                  <p-tablist>
                    <p-tab [value]="0">New</p-tab>
                    <p-tab [value]="1">Used</p-tab>
                  </p-tablist>
                  <p-tabpanels>
                    <p-tabpanel [value]="0">
                      <p-accordion [multiple]="true">
                        <p-accordion-panel value="0">
                          <p-accordion-header class="p-accordionheader">Incentives</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['incentiveConfiguration']">
                              <div class="p-field p-grid">
                                <label for="useIncentiveServiceNew" class="p-col-12 p-md-6 ng-star-inserted">Use Incentive
                                  Service
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="When enabled, the best available incentives are pulled from a service during New ad creation."
                                     tooltipPosition="right"></i>
                                </label>
                                <p-toggleswitch
                                  id="useIncentiveServiceNew"
                                  formControlName="useIncentiveService"
                                  (onChange)="setIncentiveControlsStatus()">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="enhancedIncentives" class="p-col-12 p-md-6 ng-star-inserted sub-label">Enhanced Incentives
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="When enabled, incentives and MPOP Vehicle Ad sale end dates will be automatically kept up-to-date. This feature requires that the Use Incentive Service feature is enabled."
                                     tooltipPosition="right"></i>
                                </label>
                                <p-toggleswitch
                                  id="enhancedIncentives"
                                  formControlName="enhancedIncentives"
                                  (onChange)="handleEnhancedIncentivesToggle()">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="useVinSpecificIncentivesNew" class="p-col-12 p-md-6 ng-star-inserted sub-label">Use VIN Specific Incentives
                                </label>
                                <p-toggleswitch
                                  id="useVinSpecificIncentivesNew"
                                  formControlName="useVinSpecificIncentives">
                                </p-toggleswitch>
                              </div>
                            </form>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['generalConfiguration']">
                              @if (!removeSelectInventoryIncentiveToggleEnabled) {
                                <div class="p-field p-grid">
                                  <label for="includeSelectInventoryIncentivesNew" class="p-col-12 p-md-6 ng-star-inserted sub-label">Include
                                    Select Inventory Incentives
                                  </label>
                                  <p-toggleswitch
                                    id="includeSelectInventoryIncentivesNew"
                                    formControlName="includeSelectInventoryIncentives">
                                  </p-toggleswitch>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="rebateDisclosureFormatNew" class="p-col-12 p-md-6 ng-star-inserted">Rebate
                                  Disclosure
                                  Format
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="rebateDisclosureFormatNew"
                                    [options]="rebateDisclosureFormatOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="rebateDisclosureFormat">
                                  </p-select>
                                </div>
                              </div>
                              @if (displayConditionalIncentivesAsAvailable) {
                                <div class="p-field p-grid">
                                  <label for="availableOffersLabelNew" class="p-col-12 p-md-6 ng-star-inserted">Conditional Offers Label
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="The label displayed above the Conditional Offers section. This section lists purchase incentives configured as ‘Display as Condtional’ that are excluded from pricing calculations."
                                       tooltipPosition="right"></i>
                                  </label>
                                  <div class="p-col-12 p-md-6">
                                    <input
                                      type="text"
                                      pInputText
                                      id="availableOffersLabelNew"
                                      formControlName="availableOffersLabel"
                                      [ngClass]="{'p-invalid': masterFormGroup.controls['New']['controls']['generalConfiguration'].controls.availableOffersLabel.invalid && masterFormGroup.controls['New']['controls']['generalConfiguration'].controls.availableOffersLabel.touched}">
                                    @if (masterFormGroup.controls['New']['controls']['generalConfiguration'].controls.availableOffersLabel.invalid && masterFormGroup.controls['New']['controls']['generalConfiguration'].controls.availableOffersLabel.touched) {
                                      <small class="p-error">
                                        Label is required and must be 100 characters or less.
                                      </small>
                                    }
                                  </div>
                                </div>
                              }
                              <auto-conditional-incentive-configurator
                                [accountId]="accountId"
                                [conditionalIncentiveFeatureFlagEnabled]="conditionalIncentiveFeatureFlagEnabled"
                                [applicationValues]="applicationValues"
                                (formDirty)="handleConditionalIncentiveFormDirty($event)"
                                (formValid)="setConditionalIncentiveFormValid($event)">
                              </auto-conditional-incentive-configurator>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <auto-offer-rules
                          [accountId]="accountId"
                          [condition]="'New'"
                          (formDirty)="handleOfferRulesFormDirty($event)"
                          (deleteRules)="handleDeleteOfferRules()">
                        </auto-offer-rules>
                        <p-accordion-panel value="2">
                          <p-accordion-header>Fees</p-accordion-header>
                          <p-accordion-content>
                            @if (dynamicFeesTableEnabled) {
                              <div [formGroup]="masterFormGroup.controls['New']['controls']['feesConfiguration']">
                                <auto-dynamic-fees-table
                                  [feesConfigurationFormGroup]="masterFormGroup.controls['New']['controls']['feesConfiguration']"
                                  [categoryName]="'New'"
                                  [vinSpecificFeesEnabled]="vinSpecificFeesEnabled"
                                  [inventoryFeeMappingsLoaded]="inventoryFeeMappingsLoaded"
                                  [mappedInventoryFeeSources]="mappedInventoryFeeSources"
                                  [purchaseFeeDisplayEnabled]="isPurchaseFeeDisplayEnabled('New')">
                                </auto-dynamic-fees-table>
                                <div class="dynamic-fees-final-price-section" *ngIf="!independentFinalPriceTextEnabled">
                                  <div class="p-field p-grid">
                                    <label for="dynamic-final-price-text-new" class="p-col-12 p-md-4">Final Price Text</label>
                                    <div class="p-col-12 p-md-8">
                                      <input
                                        type="text"
                                        pInputText
                                        formControlName="finalPriceText"
                                        id="dynamic-final-price-text-new">
                                      <small class="setting-helper-text dynamic-fees-final-price-section__helper">Label displayed for the final total in the mathbox.</small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (!dynamicFeesTableEnabled) {
                            <div class="p-d-flex">
                              <form
                                [formGroup]="masterFormGroup.controls['New']['controls']['feesConfiguration']">
                                <table class="p-datatable">
                                  <thead class="p-datatable-thead">
                                  <tr class="p-datatable-header">
                                    <th class="p-mr-2">
                                      Fee
                                    </th>
                                    <th class="p-mr-2">
                                      Value
                                    </th>
                                    <th class="p-mr-2 fee-table-column">
                                      Lease
                                    </th>
                                    <th class="p-mr-2 fee-table-column">
                                      Finance
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody class="p-datatable-tbody">
                                  <tr formGroupName="documentFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'documentFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'documentFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="licenseFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'licenseFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'licenseFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="titleFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'titleFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'titleFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="acquisitionFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'acquisitionFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'acquisitionFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="taxes" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'taxes') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'taxes')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="dispositionFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('New', 'dispositionFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('New', 'dispositionFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                                <h4 class="form-section-sub-header">Purchase Fee</h4>
                                <div formGroupName="customFee">
                                  <div class="p-field p-grid">
                                    <label for="custom-fee-enabled-new" class="p-col-12 p-md-6 ng-star-inserted">Custom Purchase
                                      Fee
                                      <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                         pTooltip="When enabled, this custom purchase fee will be applied in the math box for all new ads. The mathbox will reflect a final price including applicable purchase rebates and this fee."
                                         tooltipPosition="right"></i>
                                    </label>
                                    <p-toggleswitch
                                      formControlName="enabled"
                                      id="custom-fee-enabled-new"
                                    ></p-toggleswitch>
                                <span class="setting-helper-text">When Shared Offer Sets are enabled, purchase fee configurations must remain consistent across linked accounts.</span>
                                  </div>
                                  <div class="p-grid purchase-fee-grid">
                                    <div class="p-col-6">
                                      <label for="display-name-new">Display Name</label>
                                    </div>
                                    <div class="p-col-6">
                                      <input type="text" pInputText formControlName="displayName" id="display-name-new">
                                    </div>
                                    <div class="p-col-6">
                                      <label for="value-new">Value ($)</label>
                                    </div>
                                    <div class="p-col-6">
                                      <input type="text" pInputText formControlName="value" id="value-new">
                                    </div>
                                    <div class="p-col-6">
                                      <label for="pricing-option-new">Pricing Option
                                        <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                           pTooltip="Select how the purchase fee should be handled in the sale price:
Add Purchase Fee to Sale Price – The purchase fee will be added to the sale price in the ad and reflected in the final price. The fee will also be itemized separately in the Math Box.
Purchase Fee is Included in Sale Price – The purchase fee is part of the price received from inventory. The displayed sale price in the offer will be reduced by the fee amount, which will then be itemized separately in the Math Box. This reduced price will also be used for lease and finance calculations."
                                           tooltipPosition="right"></i></label>
                                    </div>
                                    <div class="p-col-6">
                                      <p-select
                                        [options]="pricingOptions"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="pricingOption"
                                        id="pricing-option-new">
                                      </p-select>
                                    </div>
                                    <div class="p-col-6" *ngIf="!independentFinalPriceTextEnabled">
                                      <label for="final-price-text-new">Final Price Text</label>
                                    </div>
                                    <div class="p-col-6" *ngIf="!independentFinalPriceTextEnabled">
                                      <input type="text" pInputText formControlName="finalPriceText" id="final-price-text-new">
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                            }
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="3">
                          <p-accordion-header>Purchase & Savings Offers</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['purchaseConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showPurchaseOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show Purchase Offers
                                </label>
                                <p-toggleswitch
                                  id="showPurchaseOfferNew"
                                  formControlName="showPurchaseOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="showSavingsOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show Savings Offers
                                </label>
                                <p-toggleswitch
                                  id="showSavingsOfferNew"
                                  formControlName="showSavingsOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid" *ngIf="!isPurchaseFeeDisplayEnabled('New')">
                                <label for="showPreRebateSubtotalNew" class="p-col-12 p-md-6 ng-star-inserted">Show Pre-Rebate
                                  Subtotal
                                </label>
                                <p-toggleswitch
                                  id="showPreRebateSubtotalNew"
                                  formControlName="showPreRebateSubtotal">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="showLineItemSuperscriptsNew" class="p-col-12 p-md-6 ng-star-inserted">Show Line Item
                                  Superscripts
                                </label>
                                <p-toggleswitch
                                  id="showLineItemSuperscriptsNew"
                                  formControlName="showLineItemSuperscripts">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="includePurchaseDealerIncentivesNew" class="p-col-12 p-md-6 ng-star-inserted">Include
                                  Dealer Incentives
                                </label>
                                <p-toggleswitch
                                  id="includePurchaseDealerIncentivesNew"
                                  formControlName="includePurchaseDealerIncentives">
                                </p-toggleswitch>
                              </div>
                              @let showMathboxControls = masterFormGroup.get('New.purchaseConfiguration.showMathBox')?.value;
                              <section class="mathbox-settings" aria-labelledby="mathboxHeadingNew"
                                       [class.mathbox-settings--collapsed]="!showMathboxControls">
                                <header class="mathbox-settings__header mathbox-settings__header--with-toggle">
                                  <div>
                                    <h3 id="mathboxHeadingNew">Mathbox</h3>
                                    <p>Customize the labels and text styling in the price breakdown.</p>
                                  </div>
                                  <div class="mathbox-settings__toggle">
                                    <label for="showMathBoxNew">Show Mathbox</label>
                                    <p-toggleswitch
                                      inputId="showMathBoxNew"
                                      formControlName="showMathBox">
                                    </p-toggleswitch>
                                  </div>
                                </header>
                                <div class="mathbox-settings__layout" *ngIf="showMathboxControls">
                                  <div class="mathbox-settings__controls">
                                    <fieldset class="mathbox-settings__group mathbox-settings__group--dealer-discount"
                                              (focusin)="mathboxPreviewAdjustment = 'discount'">
                                      <legend>
                                        Dealer Discount
                                        <i class="pi pi-info-circle form-item-tooltip"
                                           pTooltip="Label for dealer discounts below MSRP. This is a shared account setting. Leave blank to use Discounts & Incentives."
                                           tooltipPosition="right"></i>
                                      </legend>
                                      <button type="button" class="mathbox-settings__reset"
                                              aria-label="Reset Dealer Discount to defaults"
                                              [disabled]="dealerDiscountLabelControl.disabled"
                                              (click)="resetMathboxGroup('New', 'dealerDiscountLabel')">Reset</button>
                                      <div class="mathbox-settings__field">
                                        <input id="dealerDiscountLabelNew" aria-label="Dealer Discount Label"
                                               type="text" pInputText formControlName="dealerDiscountLabel"
                                               [placeholder]="defaultDealerDiscountLabel"
                                               [maxlength]="dealerDiscountLabelMaxLength"
                                               aria-describedby="dealerDiscountLabelNewError"
                                               [attr.aria-invalid]="dealerDiscountLabelControl.invalid">
                                        <small id="dealerDiscountLabelNewError" class="p-error" role="alert"
                                               *ngIf="dealerDiscountLabelControl.invalid && (dealerDiscountLabelControl.dirty || dealerDiscountLabelControl.touched)">
                                          Use {{ dealerDiscountLabelMaxLength }} characters or fewer.
                                        </small>
                                        <small class="mathbox-settings__default" *ngIf="dealerDiscountLabelControl.disabled">
                                          Dealer Discount label could not be loaded. Reload to try again.
                                        </small>
                                      </div>
                                    </fieldset>
                                    <fieldset class="mathbox-settings__group mathbox-settings__group--dealer-add-on" *ngIf="dealerAddOnLabelEnabled"
                                              (focusin)="mathboxPreviewAdjustment = 'addOn'">
                                      <legend>
                                        Dealer Add-On
                                        <i class="pi pi-info-circle form-item-tooltip"
                                           pTooltip="Label for dealer add-ons above MSRP. Leave blank to use Dealer Add-On &amp; Adjustment."
                                           tooltipPosition="right"></i>
                                      </legend>
                                      <button type="button" class="mathbox-settings__reset"
                                              aria-label="Reset Dealer Add-On to defaults"
                                              (click)="resetMathboxGroup('New', 'dealerAddOnLabel')">Reset</button>
                                      <div class="mathbox-settings__field">
                                        <input
                                          id="dealerAddOnLabelNew"
                                          aria-label="Dealer Add-On Label"
                                          type="text"
                                          pInputText
                                          formControlName="dealerAddOnLabel"
                                          [placeholder]="defaultDealerAddOnLabel"
                                          [attr.aria-invalid]="dealerAddOnLabelControl?.invalid">
                                        <small class="p-error" role="alert"
                                               *ngIf="dealerAddOnLabelControl?.dirty || dealerAddOnLabelControl?.touched">
                                          <span *ngIf="dealerAddOnLabelControl?.hasError('dealerAddOnLabelLength')">
                                            Use {{ dealerAddOnLabelMaxLength }} characters or fewer.
                                          </span>
                                          <span *ngIf="dealerAddOnLabelControl?.hasError('dealerAddOnLabelType')">
                                            Enter a text label.
                                          </span>
                                        </small>
                                      </div>
                                    </fieldset>
                                    <fieldset class="mathbox-settings__group mathbox-settings__group--subtotal"
                                              *ngIf="carsActTotalPriceEnabled || isPurchaseFeeDisplayEnabled('New')">
                                      <legend>
                                        Price Subtotal
                                        <i *ngIf="carsActTotalPriceEnabled" class="pi pi-info-circle form-item-tooltip"
                                           pTooltip="Controls the label displayed for the pre-rebate price subtotal in the mathbox. The default label is Sale Price."
                                           tooltipPosition="right"></i>
                                      </legend>
                                      @if (carsActTotalPriceEnabled) {
                                        <button type="button" class="mathbox-settings__reset"
                                                aria-label="Reset Price Subtotal to defaults"
                                                (click)="resetMathboxGroup('New', 'priceSubtotalLabel')">Reset</button>
                                        <div class="mathbox-settings__field">
                                          <input
                                            id="priceSubtotalLabelNew"
                                            aria-label="Price Subtotal Label"
                                            type="text"
                                            pInputText
                                            [placeholder]="defaultPriceSubtotalLabel"
                                            formControlName="priceSubtotalLabel"
                                            [maxlength]="priceSubtotalLabelMaxLength">
                                        </div>
                                        <div class="mathbox-settings__style-fields">
                                          <div class="mathbox-settings__field">
                                            <label for="priceSubtotalFontSizeNew">Label Size</label>
                                            <p-inputnumber
                                              inputId="priceSubtotalFontSizeNew"
                                              placeholder="10 px"
                                              suffix=" px"
                                              [showButtons]="true"
                                              buttonLayout="horizontal"
                                              [min]="minimumPriceSubtotalFontSize"
                                              [step]="1"
                                              [useGrouping]="false"
                                              [maxFractionDigits]="0"
                                              [style]="{width: '100%'}"
                                              [inputStyle]="{width: '0', minWidth: '0', flex: '1 1 auto'}"
                                              formControlName="priceSubtotalFontSize">
                                            </p-inputnumber>
                                          </div>
                                          <div class="mathbox-settings__field">
                                            <label for="priceSubtotalValueFontSizeNew">Value Size</label>
                                            <p-inputnumber
                                              inputId="priceSubtotalValueFontSizeNew"
                                              placeholder="12 px"
                                              suffix=" px"
                                              [showButtons]="true"
                                              buttonLayout="horizontal"
                                              [min]="minimumPriceSubtotalFontSize"
                                              [step]="1"
                                              [useGrouping]="false"
                                              [maxFractionDigits]="0"
                                              [style]="{width: '100%'}"
                                              [inputStyle]="{width: '0', minWidth: '0', flex: '1 1 auto'}"
                                              formControlName="priceSubtotalValueFontSize">
                                            </p-inputnumber>
                                          </div>
                                          <div class="mathbox-settings__field">
                                            <label id="priceSubtotalBoldNewLabel" for="priceSubtotalBoldNew">Styling</label>
                                            <p-select
                                              inputId="priceSubtotalBoldNew"
                                              ariaLabelledBy="priceSubtotalBoldNewLabel"
                                              [options]="priceSubtotalBoldOptions"
                                              optionLabel="label"
                                              optionValue="value"
                                              formControlName="priceSubtotalBold">
                                            </p-select>
                                          </div>
                                        </div>
                                      }
                                      @if (isPurchaseFeeDisplayEnabled('New')) {
                                        <div class="mathbox-settings__field" [class.p-mt-3]="carsActTotalPriceEnabled">
                                          <div class="mathbox-settings__toggle mathbox-settings__toggle--subtotal">
                                            <label for="showSubtotalWithoutFeesNew" class="p-mb-0">Show When No Fees Are Above</label>
                                            <p-toggleswitch
                                              inputId="showSubtotalWithoutFeesNew"
                                              formControlName="showPreRebateSubtotal"
                                              [pTooltip]="subtotalVisibilityTooltip"
                                              tooltipPosition="right"
                                              tooltipEvent="both"
                                              [pt]="{input: {'aria-describedby': 'subtotalVisibilityHelpNew'}}">
                                            </p-toggleswitch>
                                          </div>
                                          <small id="subtotalVisibilityHelpNew" class="mathbox-settings__default">{{ subtotalVisibilityTooltip }}</small>
                                        </div>
                                      }
                                    </fieldset>
                                    <fieldset class="mathbox-settings__group mathbox-settings__group--final-price" *ngIf="independentFinalPriceTextEnabled">
                                      <legend>
                                        Final Price
                                        <i class="pi pi-info-circle form-item-tooltip"
                                           pTooltip="Label for the final price below any fees. Leave blank to restore the default."
                                           tooltipPosition="right"></i>
                                      </legend>
                                      <button type="button" class="mathbox-settings__reset"
                                              aria-label="Reset Final Price to defaults"
                                              (click)="resetMathboxGroup('New', 'finalPriceText')">Reset</button>
                                      <div class="mathbox-settings__field">
                                        <input
                                          id="independentFinalPriceTextNew"
                                          aria-label="Final Price Label"
                                          type="text"
                                          pInputText
                                          formControlName="finalPriceText"
                                          [placeholder]="getMathboxFinalPriceDefault('New')"
                                          aria-describedby="independentFinalPriceTextNewDefault independentFinalPriceTextNewError"
                                          [attr.aria-invalid]="finalPriceTextControls.New?.invalid">
                                        <small id="independentFinalPriceTextNewDefault" class="mathbox-settings__default"
                                               *ngIf="!finalPriceTextControls.New?.value?.trim()">
                                          Blank uses {{ getMathboxFinalPriceDefault('New') }}.
                                        </small>
                                        <small id="independentFinalPriceTextNewError" class="p-error" role="alert">
                                          @if (finalPriceTextControls.New?.dirty || finalPriceTextControls.New?.touched) {
                                            <span *ngIf="finalPriceTextControls.New?.hasError('finalPriceTextLength')">
                                              Use {{ finalPriceTextMaxLength }} characters or fewer.
                                            </span>
                                            <span *ngIf="finalPriceTextControls.New?.hasError('finalPriceTextType')">
                                              Enter a valid text label.
                                            </span>
                                          }
                                        </small>
                                      </div>
                                      <div class="mathbox-settings__style-fields">
                                        <div class="mathbox-settings__field">
                                          <label for="finalPriceFontSizeNew">Label Size</label>
                                          <p-inputnumber
                                            inputId="finalPriceFontSizeNew"
                                            placeholder="10 px"
                                            suffix=" px"
                                            [showButtons]="true"
                                            buttonLayout="horizontal"
                                            [min]="minimumFinalPriceFontSize"
                                            [step]="1"
                                            [useGrouping]="false"
                                            [maxFractionDigits]="0"
                                            [style]="{width: '100%'}"
                                            [inputStyle]="{width: '0', minWidth: '0', flex: '1 1 auto'}"
                                            formControlName="finalPriceFontSize">
                                          </p-inputnumber>
                                        </div>
                                        <div class="mathbox-settings__field">
                                          <label for="finalPriceValueFontSizeNew">Value Size</label>
                                          <p-inputnumber
                                            inputId="finalPriceValueFontSizeNew"
                                            placeholder="12 px"
                                            suffix=" px"
                                            [showButtons]="true"
                                            buttonLayout="horizontal"
                                            [min]="minimumFinalPriceFontSize"
                                            [step]="1"
                                            [useGrouping]="false"
                                            [maxFractionDigits]="0"
                                            [style]="{width: '100%'}"
                                            [inputStyle]="{width: '0', minWidth: '0', flex: '1 1 auto'}"
                                            formControlName="finalPriceValueFontSize">
                                          </p-inputnumber>
                                        </div>
                                        <div class="mathbox-settings__field">
                                          <label id="finalPriceBoldNewLabel" for="finalPriceBoldNew">Styling</label>
                                          <p-select
                                            inputId="finalPriceBoldNew"
                                            ariaLabelledBy="finalPriceBoldNewLabel"
                                            [options]="priceSubtotalBoldOptions"
                                            optionLabel="label"
                                            optionValue="value"
                                            formControlName="finalPriceBold">
                                          </p-select>
                                        </div>
                                      </div>
                                    </fieldset>
                                  </div>
                                  <aside class="mathbox-settings__preview" aria-label="New vehicle mathbox preview">
                                    <ng-container *ngTemplateOutlet="mathboxPreview; context: {$implicit: 'New'}"></ng-container>
                                  </aside>
                                </div>
                              </section>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="4">
                          <p-accordion-header>Lease Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['leaseConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showLeaseOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show Lease Offers
                                </label>
                                <p-toggleswitch
                                  id="showLeaseOfferNew"
                                  formControlName="showLeaseOffer">
                                </p-toggleswitch>
                              </div>
                              @if (hideLeaseOfferWithDealerAddonEnabled) {
                                <div class="p-field p-grid">
                                  <label for="hideLeaseOfferWithDealerAddonNew" class="p-col-12 p-md-6 ng-star-inserted">Hide Lease with Add-ons
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="When enabled, Lease Offers will be hidden if a Dealer Add-on is present in the Offer Set."
                                       tooltipPosition="right"></i>
                                  </label>
                                  <p-toggleswitch
                                    id="hideLeaseOfferWithDealerAddonNew"
                                    formControlName="hideLeaseOfferWithDealerAddon">
                                  </p-toggleswitch>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="showAlternateLeaseOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show Alternate
                                  Lease Offers
                                </label>
                                <p-toggleswitch
                                  id="showAlternateLeaseOfferNew"
                                  formControlName="showAlternateLeaseOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="leaseSellingPriceTypeNew" class="p-col-12 p-md-6 ng-star-inserted">Selling Price
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="leaseSellingPriceTypeNew"
                                    [options]="leaseSellingPriceOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="leaseSellingPriceType">
                                  </p-select>
                                </div>
                              </div>
                              @if (lowestEstimatedPaymentTermEnabled) {
                                <div class="p-field p-grid">
                                  <label for="leaseTermSelectionNew" class="p-col-12 p-md-6 ng-star-inserted">Lease Term Selection
                                  </label>
                                  <div class="p-col-12 p-md-6">
                                    <p-select
                                      id="leaseTermSelectionNew"
                                      [options]="leaseTermSelectionOptions"
                                      optionLabel="label"
                                      optionValue="value"
                                      formControlName="leaseTermSelection"
                                      (onChange)="handleLeaseTermSelectionChange()">
                                    </p-select>
                                    @if (shouldShowLeaseTermSelectionExplanation()) {
                                      <small class="setting-helper-text">{{leaseTermSelectionExplanation}}</small>
                                    }
                                  </div>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="calculateLeaseFrom" class="p-col-12 p-md-6 ng-star-inserted">Lease Down Calculation
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="Adjusting this setting will change the lease payment calculation method.

                                 A lease 'down payment' is a portion of the vehicle's cost paid upfront and reduces monthly lease payments. 'Due at signing' is the total amount due at the time of signing and includes the down payment, first month's payment, plus any fees required to start the lease."
                                     tooltipPosition="right"></i>
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <div class="p-grid purchase-fee-grid">
                                    <div class="p-col-12 p-md-4">
                                      <p-select
                                        id="calculateLeaseFrom"
                                        [options]="calculateLeaseFromOptions"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="calculateLeaseFrom">
                                      </p-select>
                                    </div>
                                    <div class="p-col-12 p-md-2">
                                      <input pInputText
                                             id="leaseDownDueAmount"
                                             formControlName="leaseDownDueAmount"
                                             type="number"
                                             step="0.001"
                                      />
                                    </div>
                                    <div class="p-col-12 p-md-2">
                                      <p-select
                                        id="leasePaymentType"
                                        [options]="leasePaymentTypeOptions"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="leasePaymentType">
                                      </p-select>
                                    </div>
                                    @if (leasePaymentTypeControl.value === 'percent') {
                                      <div class="p-col-12 p-md-4">
                                        <div class="lease-pricing-base-wrapper purchase-fee-grid">
                                          <div class="p-col-2">
                                            <label for="leasePricingBase">of
                                            </label>
                                          </div>
                                          <div class="p-col-10">
                                            <p-select
                                              id="leasePricingBase"
                                              [options]="leasePricingBaseOptions"
                                              optionLabel="label"
                                              optionValue="value"
                                              formControlName="leasePricingBase">
                                            </p-select>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                  <small class="setting-helper-text lease-setting-helper-text">Determines how the upfront amount and monthly lease payment are calculated.</small>
                                </div>
                              </div>
                              @if (offerSetRecalculationOnSettingSaveEnabled) {
                                <div class="p-field p-grid">
                                  <label for="leaseDownTextNew" class="p-col-12 p-md-6 ng-star-inserted">Cash Down
                                    Label</label>
                                  <div class="p-col-12 p-md-6">
                                    <p-select id="leaseDownTextNew" [options]="leaseDownTextOptions" optionLabel="label"
                                              optionValue="value" formControlName="leaseDownText"></p-select>
                                    <small class="setting-helper-text lease-setting-helper-text">Determines whether the Offer Set shows the down payment or the total due at signing.</small>
                                  </div>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="includeLeaseDealerIncentivesNew" class="p-col-12 p-md-6 ng-star-inserted">Include
                                  Dealer
                                  Incentives
                                </label>
                                <p-toggleswitch
                                  id="includeLeaseDealerIncentivesNew"
                                  formControlName="includeLeaseDealerIncentives">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="leaseIncentiveTypeNew" class="p-col-12 p-md-6 ng-star-inserted">Lease Incentive
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="leaseIncentiveTypeNew"
                                    [options]="leaseIncentiveTypeOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="leaseIncentiveType">
                                  </p-select>
                                </div>
                              </div>
                              <div class="p-grid purchase-fee-grid">
                                <div class="p-col-6">
                                  <label for="moneyFactorMarkupNew">Money Factor Markup
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="The markup is added to the best rate from the Incentive Service. Lease APR/2400 converts percentage value to money factor."
                                       tooltipPosition="right"></i>
                                  </label>
                                </div>
                                <div class="p-col-6">
                                  <input pInputText
                                         id="moneyFactorMarkupNew"
                                         formControlName="moneyFactorMarkup"
                                         type="number"
                                         step="0.01"
                                  />
                                </div>
                                @if (newMoneyFactorMarkupControl.invalid) {
                                  <span                              class="p-invalid p-col-12 p-md-6 ng-star-inserted">
                            Money Factor Markup must be a decimal value less than 1.
                          </span>
                                }
                              </div>
                              @if (offerSetRecalculationOnSettingSaveEnabled) {
                                <div class="p-field p-grid">
                                  <label for="leasePaymentTermNew" class="p-col-12 p-md-6 ng-star-inserted">Lease
                                    Payment Term</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="leasePaymentTermNew" formControlName="leasePaymentTerm"
                                           type="number" step="1"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="leaseMilesPerYearNew" class="p-col-12 p-md-6 ng-star-inserted">Lease Miles
                                    per Year</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="leaseMilesPerYearNew" formControlName="leaseMilesPerYear"
                                           type="number" step="500"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="leaseCentsPerMileNew" class="p-col-12 p-md-6 ng-star-inserted">Lease
                                    Cents/Mile</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="leaseCentsPerMileNew" formControlName="leaseCentsPerMile"
                                           type="number" step="1"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="alternateLeaseCentsPerMileNew" class="p-col-12 p-md-6 ng-star-inserted">Alternate
                                    Lease Cents/Mile</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="alternateLeaseCentsPerMileNew"
                                           formControlName="alternateLeaseCentsPerMile" type="number" step="1"/>
                                  </div>
                                </div>
                              }
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="5">
                          <p-accordion-header>Finance Offer</p-accordion-header>
                          <p-accordion-content>
                            @if (offerSetRecalculationOnSettingSaveEnabled) {
                              <form [formGroup]="masterFormGroup.controls['New']['controls']['generalConfiguration']">
                                <div class="p-field p-grid">
                                  <label for="useRateTableNew" class="p-col-12 p-md-6 ng-star-inserted">Use Rate Table</label>
                                  <p-toggleswitch
                                    id="useRateTableNew"
                                    formControlName="useRateTable">
                                  </p-toggleswitch>
                                </div>
                              </form>
                            }
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['financeConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showFinanceOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show Finance Offers
                                </label>
                                <p-toggleswitch
                                  id="showFinanceOfferNew"
                                  formControlName="showFinanceOffer">
                                </p-toggleswitch>
                              </div>
                              @if (hideFinanceOfferWithDealerAddonEnabled) {
                                <div class="p-field p-grid">
                                  <label for="hideFinanceOfferWithDealerAddonNew" class="p-col-12 p-md-6 ng-star-inserted">Hide Finance with Add-ons
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="When enabled, Finance Offers will be hidden if a Dealer Add-on is present in the Offer Set."
                                       tooltipPosition="right"></i>
                                  </label>
                                  <p-toggleswitch
                                    id="hideFinanceOfferWithDealerAddonNew"
                                    formControlName="hideFinanceOfferWithDealerAddon">
                                  </p-toggleswitch>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="financeAprSourceNew" class="p-col-12 p-md-6 ng-star-inserted">Finance APR Source
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="When Incentive Service is selected, the Finance APR with the longest term is pulled from the Real-Time Incentive Service. When Account Defaults is selected, the Finance APR will come from the defaults configured for the account."
                                     tooltipPosition="right"></i>
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="financeAprSourceNew"
                                    [options]="financeAprSourceOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="financeAprSource">
                                  </p-select>
                                </div>
                              </div>
                              <div class="p-field p-grid">
                                <label for="downPaymentBasedOnNew" class="p-col-12 p-md-6 ng-star-inserted">Down Payment Based On
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="Determines whether the down payment is calculated using the vehicle’s MSRP or the Buy Price."
                                     tooltipPosition="right"></i>
                                </label>
                                <div class="p-col-12 p-md-6">
                                <p-select
                                  id="downPaymentBasedOnNew"
                                  [options]="downPaymentBasedOnOptions"
                                  optionLabel="label"
                                  optionValue="value"
                                  formControlName="downPaymentBasedOn">
                                </p-select>
                                </div>
                              </div>
                              <div class="p-field p-grid">
                                <label for="includeFinanceDealerIncentivesNew" class="p-col-12 p-md-6 ng-star-inserted">Include
                                  Dealer Incentives
                                </label>
                                <p-toggleswitch
                                  id="includeFinanceDealerIncentivesNew"
                                  formControlName="includeFinanceDealerIncentives">
                                </p-toggleswitch>
                              </div>
                              @if (offerSetRecalculationOnSettingSaveEnabled) {
                                <div class="p-field p-grid">
                                  <label for="showFinancePaymentNew" class="p-col-12 p-md-6 ng-star-inserted">Finance
                                    Payment</label>
                                  <p-toggleswitch id="showFinancePaymentNew"
                                                  formControlName="showFinancePayment"></p-toggleswitch>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="financePaymentAprNew" class="p-col-12 p-md-6 ng-star-inserted">Finance
                                    Payment APR</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="financePaymentAprNew" formControlName="financePaymentApr"
                                           type="number" step="0.01"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="showFinanceAprNew" class="p-col-12 p-md-6 ng-star-inserted">Show Finance
                                    APR in Offer Set</label>
                                  <p-toggleswitch id="showFinanceAprNew"
                                                  formControlName="showFinanceApr"></p-toggleswitch>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="financePaymentTermNew" class="p-col-12 p-md-6 ng-star-inserted">Finance
                                    Payment Term</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="financePaymentTermNew" formControlName="financePaymentTerm"
                                           type="number" step="1"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="financeDownPaymentTypeNew" class="p-col-12 p-md-6 ng-star-inserted">Finance
                                    Down Payment Type</label>
                                  <div class="p-col-12 p-md-6">
                                    <p-select id="financeDownPaymentTypeNew" [options]="getFinancePaymentDownTypeOptions('New')"
                                              optionLabel="label" optionValue="value"
                                              formControlName="financeDownPaymentType"
                                              (onChange)="handleFinanceDownPaymentTypeChange('New')"></p-select>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="financeDownPaymentAmountNew" class="p-col-12 p-md-6 ng-star-inserted">Finance
                                    Down Payment</label>
                                  <div class="p-col-12 p-md-6">
                                    @if (isFinanceDownPaymentFromRateTable('New')) {
                                      <span class="setting-helper-text"><i>Use from Rate Table</i></span>
                                    } @else if (masterFormGroup.controls['New']['controls']['financeConfiguration'].controls.financeDownPaymentType.value === 'percent') {
                                      <p-select id="financeDownPaymentAmountNew"
                                                [options]="financePaymentDownPercentageOptions"
                                                optionLabel="label" optionValue="value"
                                                formControlName="financeDownPaymentAmount"></p-select>
                                    } @else {
                                      <div class="p-inputgroup finance-down-payment-input">
                                        <span class="p-inputgroup-addon" aria-hidden="true">$</span>
                                        <input pInputText id="financeDownPaymentAmountNew"
                                               formControlName="financeDownPaymentAmount" type="number" step="0.01"
                                               min="0" placeholder="---"/>
                                      </div>
                                    }
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="showFinanceDownPaymentNew" class="p-col-12 p-md-6 ng-star-inserted">Show
                                    Finance Down Payment in Offer Set</label>
                                  <p-toggleswitch id="showFinanceDownPaymentNew"
                                                  formControlName="showFinanceDownPayment"></p-toggleswitch>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="daysToFirstPaymentNew" class="p-col-12 p-md-6 ng-star-inserted">Days to
                                    First Payment</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="daysToFirstPaymentNew" formControlName="daysToFirstPayment"
                                           type="number" step="1"/>
                                  </div>
                                </div>
                              }
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="6">
                          <p-accordion-header>APR Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['New']['controls']['aprConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showAprOfferNew" class="p-col-12 p-md-6 ng-star-inserted">Show APR Offers
                                </label>
                                <p-toggleswitch
                                  id="showAprOfferNew"
                                  formControlName="showAprOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="useChromeIncentivesAprOfferNew" class="p-col-12 p-md-6 ng-star-inserted"> APR Source
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="When using the Incentive Service, the lowest available Finance APR with the longest correlating term is applied. When no APR is found, the Account Default is used as a fallback if available."
                                     tooltipPosition="right"></i>
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="useChromeIncentivesAprOfferNew"
                                    [options]="aprSourceOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="useChromeIncentivesAprOffer">
                                  </p-select>
                                </div>
                              </div>
                              @if (offerSetRecalculationOnSettingSaveEnabled) {
                                <div class="p-field p-grid">
                                  <label for="aprPricingRateNew" class="p-col-12 p-md-6 ng-star-inserted">APR Pricing
                                    Rate</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="aprPricingRateNew" formControlName="aprPricingRate"
                                           type="number" step="0.01"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="aprPricingTermNew" class="p-col-12 p-md-6 ng-star-inserted">APR Pricing
                                    Term</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="aprPricingTermNew" formControlName="aprPricingTerm"
                                           type="number" step="1"/>
                                  </div>
                                </div>
                              }
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                      </p-accordion>
                    </p-tabpanel>
                    <p-tabpanel [value]="1">
                      <p-accordion [multiple]="true">
                        <auto-offer-rules
                          [accountId]="accountId"
                          [condition]="'Used'"
                          (formDirty)="handleOfferRulesFormDirty($event)"
                          (deleteRules)="handleDeleteOfferRules()">
                        </auto-offer-rules>
                        <p-accordion-panel value="2">
                          <p-accordion-header>Fees</p-accordion-header>
                          <p-accordion-content>
                            @if (dynamicFeesTableEnabled) {
                              <div [formGroup]="masterFormGroup.controls['Used']['controls']['feesConfiguration']">
                                <auto-dynamic-fees-table
                                  [feesConfigurationFormGroup]="masterFormGroup.controls['Used']['controls']['feesConfiguration']"
                                  [categoryName]="'Used'"
                                  [vinSpecificFeesEnabled]="vinSpecificFeesEnabled"
                                  [inventoryFeeMappingsLoaded]="inventoryFeeMappingsLoaded"
                                  [mappedInventoryFeeSources]="mappedInventoryFeeSources">
                                </auto-dynamic-fees-table>
                                <div class="dynamic-fees-final-price-section" *ngIf="!independentFinalPriceTextEnabled">
                                  <div class="p-field p-grid">
                                    <label for="dynamic-final-price-text-used" class="p-col-12 p-md-4">Final Price Text</label>
                                    <div class="p-col-12 p-md-8">
                                      <input
                                        type="text"
                                        pInputText
                                        formControlName="finalPriceText"
                                        id="dynamic-final-price-text-used">
                                      <small class="setting-helper-text dynamic-fees-final-price-section__helper">This label is shared across all purchase fee rows.</small>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (!dynamicFeesTableEnabled) {
                            <div class="p-d-flex">
                              <form
                                [formGroup]="masterFormGroup.controls['Used']['controls']['feesConfiguration']">
                                <table class="p-datatable">
                                  <thead class="p-datatable-thead">
                                  <tr class="p-datatable-header">
                                    <th class="p-mr-2">
                                      Fee
                                    </th>
                                    <th class="p-mr-2">
                                      Value
                                    </th>
                                    <th class="p-mr-2 fee-table-column">
                                      Lease
                                    </th>
                                    <th class="p-mr-2 fee-table-column">
                                      Finance
                                    </th>
                                  </tr>
                                  </thead>
                                  <tbody class="p-datatable-tbody">
                                  <tr formGroupName="documentFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'documentFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'documentFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionLabel="label"
                                        optionValue="value"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="licenseFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'licenseFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'licenseFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="titleFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'titleFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'titleFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="acquisitionFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'acquisitionFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'acquisitionFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="taxes" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'taxes') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'taxes')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  <tr formGroupName="dispositionFee" class="p-mb-2">
                                    <td class="p-mr-2">
                                      {{getLegacyFeeTypeLabel('Used', 'dispositionFee') | sentenceCase}}
                                      {{getLegacyFeeValueSuffix('Used', 'dispositionFee')}}
                                    </td>
                                    <td class="p-mr-2">
                                      <input type="text" pInputText formControlName="value">
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="leaseApplication">
                                      </p-select>
                                    </td>
                                    <td class="p-mr-2">
                                      <p-select
                                        [options]="feeType"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="financeApplication">
                                      </p-select>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                                <h4 class="form-section-sub-header">Purchase Fee</h4>
                                <div formGroupName="customFee">
                                  <div class="p-field p-grid">
                                    <label for="custom-fee-enabled-used" class="p-col-12 p-md-6 ng-star-inserted">Custom
                                      Purchase
                                      Fee
                                      <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                         pTooltip="When enabled, this custom purchase fee will be applied in the math box for all used ads. The mathbox will reflect a final price including applicable purchase rebates and this fee."
                                         tooltipPosition="right"></i>
                                    </label>
                                    <p-toggleswitch
                                      formControlName="enabled"
                                      id="custom-fee-enabled-used"
                                    ></p-toggleswitch>
                                <span class="setting-helper-text">When Shared Offer Sets are enabled, purchase fee configurations must remain consistent across linked accounts.</span>
                                  </div>
                                  <div class="p-grid purchase-fee-grid">
                                    <div class="p-col-6">
                                      <label for="display-name-used">Display Name</label>
                                    </div>
                                    <div class="p-col-6">
                                      <input type="text" pInputText formControlName="displayName" id="display-name-used">
                                    </div>
                                    <div class="p-col-6">
                                      <label for="value-used">Value ($)</label>
                                    </div>
                                    <div class="p-col-6">
                                      <input type="text" pInputText formControlName="value" id="value-used">
                                    </div>
                                    <div class="p-col-6">
                                      <label for="pricing-option-existing">Pricing Option
                                        <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                           pTooltip="Select how the purchase fee should be handled in the sale price:
Add Purchase Fee to Sale Price – The purchase fee will be added to the sale price in the ad and reflected in the final price. The fee will also be itemized separately in the Math Box.
Purchase Fee is Included in Sale Price – The purchase fee is part of the price received from inventory. The displayed sale price in the offer will be reduced by the fee amount, which will then be itemized separately in the Math Box. This reduced price will also be used for lease and finance calculations."
                                           tooltipPosition="right"></i></label>
                                    </div>
                                    <div class="p-col-6">
                                      <p-select
                                        [options]="pricingOptions"
                                        optionValue="value"
                                        optionLabel="label"
                                        formControlName="pricingOption"
                                        id="pricing-option-existing">
                                      </p-select>
                                    </div>
                                    <div class="p-col-6" *ngIf="!independentFinalPriceTextEnabled">
                                      <label for="final-price-text-used">Final Price Text</label>
                                    </div>
                                    <div class="p-col-6" *ngIf="!independentFinalPriceTextEnabled">
                                      <input type="text" pInputText formControlName="finalPriceText" id="final-price-text-used">
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                            }
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="3">
                          <p-accordion-header>Purchase & Savings Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['Used']['controls']['purchaseConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showPurchaseOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Purchase Offers
                                </label>
                                <p-toggleswitch
                                  id="showPurchaseOfferUsed"
                                  formControlName="showPurchaseOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="showSavingsOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Savings Offers
                                </label>
                                <p-toggleswitch
                                  id="showSavingsOfferUsed"
                                  formControlName="showSavingsOffer">
                                </p-toggleswitch>
                              </div>
                              <section class="mathbox-settings" aria-labelledby="mathboxHeadingUsed"
                                       *ngIf="independentFinalPriceTextEnabled">
                                <header class="mathbox-settings__header">
                                  <h3 id="mathboxHeadingUsed">Mathbox</h3>
                                  <p>Customize the labels and text styling in the price breakdown.</p>
                                </header>
                                <div class="mathbox-settings__layout">
                                  <div class="mathbox-settings__controls">
                                    <fieldset class="mathbox-settings__group mathbox-settings__group--final-price" *ngIf="independentFinalPriceTextEnabled">
                                      <legend>
                                        Final Price
                                        <i class="pi pi-info-circle form-item-tooltip"
                                           pTooltip="Label for the final price below any fees. Leave blank to restore the default."
                                           tooltipPosition="right"></i>
                                      </legend>
                                      <button type="button" class="mathbox-settings__reset"
                                              aria-label="Reset Final Price to defaults"
                                              (click)="resetMathboxGroup('Used', 'finalPriceText')">Reset</button>
                                      <div class="mathbox-settings__field">
                                        <input
                                          id="independentFinalPriceTextUsed"
                                          aria-label="Final Price Label"
                                          type="text"
                                          pInputText
                                          formControlName="finalPriceText"
                                          [placeholder]="getMathboxFinalPriceDefault('Used')"
                                          aria-describedby="independentFinalPriceTextUsedDefault independentFinalPriceTextUsedError"
                                          [attr.aria-invalid]="finalPriceTextControls.Used?.invalid">
                                        <small id="independentFinalPriceTextUsedDefault" class="mathbox-settings__default"
                                               *ngIf="!finalPriceTextControls.Used?.value?.trim()">
                                          Blank uses {{ getMathboxFinalPriceDefault('Used') }}.
                                        </small>
                                        <small id="independentFinalPriceTextUsedError" class="p-error" role="alert">
                                          @if (finalPriceTextControls.Used?.dirty || finalPriceTextControls.Used?.touched) {
                                            <span *ngIf="finalPriceTextControls.Used?.hasError('finalPriceTextLength')">
                                              Use {{ finalPriceTextMaxLength }} characters or fewer.
                                            </span>
                                            <span *ngIf="finalPriceTextControls.Used?.hasError('finalPriceTextType')">
                                              Enter a valid text label.
                                            </span>
                                          }
                                        </small>
                                      </div>
                                      <div class="mathbox-settings__style-fields">
                                        <div class="mathbox-settings__field">
                                          <label for="finalPriceFontSizeUsed">Label Size</label>
                                          <p-inputnumber
                                            inputId="finalPriceFontSizeUsed"
                                            placeholder="10 px"
                                            suffix=" px"
                                            [showButtons]="true"
                                            buttonLayout="horizontal"
                                            [min]="minimumFinalPriceFontSize"
                                            [step]="1"
                                            [useGrouping]="false"
                                            [maxFractionDigits]="0"
                                            [style]="{width: '100%'}"
                                            [inputStyle]="{width: '0', minWidth: '0', flex: '1 1 auto'}"
                                            formControlName="finalPriceFontSize">
                                          </p-inputnumber>
                                        </div>
                                        <div class="mathbox-settings__field">
                                          <label for="finalPriceValueFontSizeUsed">Value Size</label>
                                          <p-inputnumber
                                            inputId="finalPriceValueFontSizeUsed"
                                            placeholder="12 px"
                                            suffix=" px"
                                            [showButtons]="true"
                                            buttonLayout="horizontal"
                                            [min]="minimumFinalPriceFontSize"
                                            [step]="1"
                                            [useGrouping]="false"
                                            [maxFractionDigits]="0"
                                            [style]="{width: '100%'}"
                                            [inputStyle]="{width: '0', minWidth: '0', flex: '1 1 auto'}"
                                            formControlName="finalPriceValueFontSize">
                                          </p-inputnumber>
                                        </div>
                                        <div class="mathbox-settings__field">
                                          <label id="finalPriceBoldUsedLabel" for="finalPriceBoldUsed">Styling</label>
                                          <p-select
                                            inputId="finalPriceBoldUsed"
                                            ariaLabelledBy="finalPriceBoldUsedLabel"
                                            [options]="priceSubtotalBoldOptions"
                                            optionLabel="label"
                                            optionValue="value"
                                            formControlName="finalPriceBold">
                                          </p-select>
                                        </div>
                                      </div>
                                    </fieldset>
                                  </div>
                                  <aside class="mathbox-settings__preview" aria-label="Used vehicle mathbox preview">
                                    <ng-container *ngTemplateOutlet="mathboxPreview; context: {$implicit: 'Used'}"></ng-container>
                                  </aside>
                                </div>
                              </section>
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="4">
                          <p-accordion-header>Lease Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['Used']['controls']['leaseConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showLeaseOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Lease Offers
                                </label>
                                <p-toggleswitch
                                  id="showLeaseOfferUsed"
                                  formControlName="showLeaseOffer">
                                </p-toggleswitch>
                              </div>
                              @if (hideLeaseOfferWithDealerAddonEnabled) {
                                <div class="p-field p-grid">
                                  <label for="hideLeaseOfferWithDealerAddonUsed" class="p-col-12 p-md-6 ng-star-inserted">Hide Lease with Add-ons
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="When enabled, Lease Offers will be hidden if a Dealer Add-on is present in the Offer Set."
                                       tooltipPosition="right"></i>
                                  </label>
                                  <p-toggleswitch
                                    id="hideLeaseOfferWithDealerAddonUsed"
                                    formControlName="hideLeaseOfferWithDealerAddon">
                                  </p-toggleswitch>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="showAlternateLeaseOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Alternate
                                  Lease Offers
                                </label>
                                <p-toggleswitch
                                  id="showAlternateLeaseOfferUsed"
                                  formControlName="showAlternateLeaseOffer">
                                </p-toggleswitch>
                              </div>
                              <div class="p-field p-grid">
                                <label for="leaseSellingPriceTypeUsed" class="p-col-12 p-md-6 ng-star-inserted">Selling Price
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="leaseSellingPriceTypeUsed"
                                    [options]="leaseSellingPriceOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="leaseSellingPriceType">
                                  </p-select>
                                </div>
                              </div>
                              @if (offerSetRecalculationOnSettingSaveEnabled) {
                                <div class="p-field p-grid">
                                  <label for="leaseDownTextUsed" class="p-col-12 p-md-6 ng-star-inserted">Cash Down
                                    Label</label>
                                  <div class="p-col-12 p-md-6">
                                    <p-select id="leaseDownTextUsed" [options]="leaseDownTextOptions"
                                              optionLabel="label" optionValue="value"
                                              formControlName="leaseDownText"></p-select>
                                    <small class="setting-helper-text lease-setting-helper-text">Determines whether the Offer Set shows the down payment or the total due at signing.</small>
                                  </div>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="leaseIncentiveTypeUsed" class="p-col-12 p-md-6 ng-star-inserted">Lease Incentive
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="leaseIncentiveTypeUsed"
                                    [options]="leaseIncentiveTypeOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="leaseIncentiveType">
                                  </p-select>
                                </div>
                              </div>
                              <div class="p-grid purchase-fee-grid">
                                <div class="p-col-6">
                                  <label for="moneyFactorMarkupUsed">Money Factor Markup
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="The markup is added to the best rate from the Incentive Service. Lease APR/2400 converts percentage value to money factor."
                                       tooltipPosition="right"></i>
                                  </label>
                                </div>
                                <div class="p-col-6">
                                  <input pInputText
                                         id="moneyFactorMarkupUsed"
                                         formControlName="moneyFactorMarkup"
                                         type="number"
                                         step="0.01"
                                  />
                                </div>
                                @if (usedMoneyFactorMarkupControl.invalid) {
                                  <span                              class="p-invalid p-col-12 p-md-6 ng-star-inserted">
                Money Factor Markup must be a decimal value less than 1.
              </span>
                                }
                              </div>
                              @if (offerSetRecalculationOnSettingSaveEnabled) {
                                <div class="p-field p-grid">
                                  <label for="leasePaymentTermUsed" class="p-col-12 p-md-6 ng-star-inserted">Lease
                                    Payment Term</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="leasePaymentTermUsed" formControlName="leasePaymentTerm"
                                           type="number" step="1"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="leaseMilesPerYearUsed" class="p-col-12 p-md-6 ng-star-inserted">Lease
                                    Miles per Year</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="leaseMilesPerYearUsed" formControlName="leaseMilesPerYear"
                                           type="number" step="500"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="leaseCentsPerMileUsed" class="p-col-12 p-md-6 ng-star-inserted">Lease
                                    Cents/Mile</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="leaseCentsPerMileUsed" formControlName="leaseCentsPerMile"
                                           type="number" step="1"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="alternateLeaseCentsPerMileUsed" class="p-col-12 p-md-6 ng-star-inserted">Alternate
                                    Lease Cents/Mile</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="alternateLeaseCentsPerMileUsed"
                                           formControlName="alternateLeaseCentsPerMile" type="number" step="1"/>
                                  </div>
                                </div>
                              }
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="5">
                          <p-accordion-header>Finance Offer</p-accordion-header>
                          <p-accordion-content>
                            @if (offerSetRecalculationOnSettingSaveEnabled) {
                              <form [formGroup]="masterFormGroup.controls['Used']['controls']['generalConfiguration']">
                                <div class="p-field p-grid">
                                  <label for="useRateTableUsed" class="p-col-12 p-md-6 ng-star-inserted">Use Rate
                                    Table</label>
                                  <p-toggleswitch
                                    id="useRateTableUsed"
                                    formControlName="useRateTable">
                                  </p-toggleswitch>
                                </div>
                              </form>
                            }
                            <form [formGroup]="masterFormGroup.controls['Used']['controls']['financeConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showFinanceOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Finance Offers
                                </label>
                                <p-toggleswitch
                                  id="showFinanceOfferUsed"
                                  formControlName="showFinanceOffer">
                                </p-toggleswitch>
                              </div>
                              @if (hideFinanceOfferWithDealerAddonEnabled) {
                                <div class="p-field p-grid">
                                  <label for="hideFinanceOfferWithDealerAddonUsed" class="p-col-12 p-md-6 ng-star-inserted">Hide Finance with Add-ons
                                    <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                       pTooltip="When enabled, Finance Offers will be hidden if a Dealer Add-on is present in the Offer Set."
                                       tooltipPosition="right"></i>
                                  </label>
                                  <p-toggleswitch
                                    id="hideFinanceOfferWithDealerAddonUsed"
                                    formControlName="hideFinanceOfferWithDealerAddon">
                                  </p-toggleswitch>
                                </div>
                              }
                              <div class="p-field p-grid">
                                <label for="financeAprSourceUsed" class="p-col-12 p-md-6 ng-star-inserted">Finance APR Source
                                  <i class="p-element pi pi-info-circle form-item-tooltip ng-star-inserted"
                                     pTooltip="When Incentive Service is selected, the Finance APR with the longest term is pulled from the Real-Time Incentive Service. When Account Defaults is selected, the Finance APR will come from the defaults configured for the account."
                                     tooltipPosition="right"></i>
                                </label>
                                <div class="p-col-12 p-md-6">
                                  <p-select
                                    id="financeAprSourceUsed"
                                    [options]="usedFinanceAprSourceOptions"
                                    optionLabel="label"
                                    optionValue="value"
                                    formControlName="financeAprSource">
                                  </p-select>
                                </div>
                              </div>
                              @if (offerSetRecalculationOnSettingSaveEnabled) {
                                <div class="p-field p-grid">
                                  <label for="showFinancePaymentUsed" class="p-col-12 p-md-6 ng-star-inserted">Finance
                                    Payment</label>
                                  <p-toggleswitch id="showFinancePaymentUsed"
                                                  formControlName="showFinancePayment"></p-toggleswitch>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="financePaymentAprUsed" class="p-col-12 p-md-6 ng-star-inserted">Finance
                                    Payment APR</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="financePaymentAprUsed" formControlName="financePaymentApr"
                                           type="number" step="0.01"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="showFinanceAprUsed" class="p-col-12 p-md-6 ng-star-inserted">Show Finance
                                    APR in Offer Set</label>
                                  <p-toggleswitch id="showFinanceAprUsed"
                                                  formControlName="showFinanceApr"></p-toggleswitch>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="financePaymentTermUsed" class="p-col-12 p-md-6 ng-star-inserted">Finance
                                    Payment Term</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="financePaymentTermUsed" formControlName="financePaymentTerm"
                                           type="number" step="1"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="financeDownPaymentTypeUsed" class="p-col-12 p-md-6 ng-star-inserted">Finance
                                    Down Payment Type</label>
                                  <div class="p-col-12 p-md-6">
                                    <p-select id="financeDownPaymentTypeUsed" [options]="getFinancePaymentDownTypeOptions('Used')"
                                              optionLabel="label" optionValue="value"
                                              formControlName="financeDownPaymentType"
                                              (onChange)="handleFinanceDownPaymentTypeChange('Used')"></p-select>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="financeDownPaymentAmountUsed" class="p-col-12 p-md-6 ng-star-inserted">Finance
                                    Down Payment</label>
                                  <div class="p-col-12 p-md-6">
                                    @if (isFinanceDownPaymentFromRateTable('Used')) {
                                      <span class="setting-helper-text"><i>Use from Rate Table</i></span>
                                    } @else if (masterFormGroup.controls['Used']['controls']['financeConfiguration'].controls.financeDownPaymentType.value === 'percent') {
                                      <p-select id="financeDownPaymentAmountUsed"
                                                [options]="financePaymentDownPercentageOptions"
                                                optionLabel="label" optionValue="value"
                                                formControlName="financeDownPaymentAmount"></p-select>
                                    } @else {
                                      <div class="p-inputgroup finance-down-payment-input">
                                        <span class="p-inputgroup-addon" aria-hidden="true">$</span>
                                        <input pInputText id="financeDownPaymentAmountUsed"
                                               formControlName="financeDownPaymentAmount" type="number" step="0.01"
                                               min="0" placeholder="---"/>
                                      </div>
                                    }
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="showFinanceDownPaymentUsed" class="p-col-12 p-md-6 ng-star-inserted">Show
                                    Finance Down Payment in Offer Set</label>
                                  <p-toggleswitch id="showFinanceDownPaymentUsed"
                                                  formControlName="showFinanceDownPayment"></p-toggleswitch>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="daysToFirstPaymentUsed" class="p-col-12 p-md-6 ng-star-inserted">Days to
                                    First Payment</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="daysToFirstPaymentUsed" formControlName="daysToFirstPayment"
                                           type="number" step="1"/>
                                  </div>
                                </div>
                              }
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                        <p-accordion-panel value="6">
                          <p-accordion-header>APR Offer</p-accordion-header>
                          <p-accordion-content>
                            <form [formGroup]="masterFormGroup.controls['Used']['controls']['aprConfiguration']">
                              <div class="p-field p-grid">
                                <label for="showAprOfferUsed" class="p-col-12 p-md-6 ng-star-inserted">Show APR Offers
                                </label>
                                <p-toggleswitch
                                  id="showAprOfferUsed"
                                  formControlName="showAprOffer">
                                </p-toggleswitch>
                              </div>
                              @if (offerSetRecalculationOnSettingSaveEnabled) {
                                <div class="p-field p-grid">
                                  <label for="aprPricingRateUsed" class="p-col-12 p-md-6 ng-star-inserted">APR Pricing
                                    Rate</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="aprPricingRateUsed" formControlName="aprPricingRate"
                                           type="number" step="0.01"/>
                                  </div>
                                </div>
                                <div class="p-field p-grid">
                                  <label for="aprPricingTermUsed" class="p-col-12 p-md-6 ng-star-inserted">APR Pricing
                                    Term</label>
                                  <div class="p-col-12 p-md-6">
                                    <input pInputText id="aprPricingTermUsed" formControlName="aprPricingTerm"
                                           type="number" step="1"/>
                                  </div>
                                </div>
                              }
                            </form>
                          </p-accordion-content>
                        </p-accordion-panel>
                      </p-accordion>
                    </p-tabpanel>
                  </p-tabpanels>
                </p-tabs>
              </form>
              <div class="modal-button-wrapper">
                <p-confirmDialog
                  key="documentFeeWarning"
                  [style]="{ width: '32rem' }"
                  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"></p-confirmDialog>
              </div>
              @if (offerSetRecalculationOnSettingSaveEnabled) {
                <p-dialog
                  header="Save Ad Type Settings"
                  [(visible)]="showVehicleAdsSaveDialog"
                  [modal]="true"
                  [draggable]="false"
                  [resizable]="false"
                  [dismissableMask]="false">
                  @if (isVehicleAdsSyncOnly) {
                    <p>No settings have changed. Save &amp; Sync refreshes the affected Offer Sets. Save &amp; Skip closes this dialog without requesting a refresh.</p>
                  } @else {
                    <p>Save &amp; Skip stores these settings without updating existing Offer Sets. Save &amp; Sync stores them and dispatches an update for existing Offer Sets.</p>
                  }
                  <ng-template pTemplate="footer">
                    <button
                      pButton
                      type="button"
                      label="Save & Skip"
                      class="p-button-secondary"
                      [disabled]="isSavingVehicleAds"
                      (click)="onVehicleAdsSaveWithoutSync()">
                    </button>
                    <button
                      pButton
                      type="button"
                      label="Save & Sync"
                      class="p-button-success"
                      [disabled]="isSavingVehicleAds"
                      (click)="onVehicleAdsSaveAndSync()">
                    </button>
                    <button
                      pButton
                      type="button"
                      label="Cancel"
                      class="p-button-danger"
                      [disabled]="isSavingVehicleAds"
                      (click)="onVehicleAdsSaveCancelled()">
                    </button>
                  </ng-template>
                </p-dialog>
              }
            }
          </div>
        }
      </p-panel>
</p-panel>
</div>
</p-panel>
<auto-footer></auto-footer>

<ng-template #mathboxPreview let-category>
  @let fees = getMathboxPreviewFees(category);
  @let pricing = getMathboxPreviewPricing(category, fees);
  <div class="mathbox-preview">
    <div class="mathbox-preview__heading">
      <h4>Live preview</h4>
      <span class="mathbox-preview__badge">Sample prices</span>
    </div>
    <p class="mathbox-preview__description">Changes appear here before saving. Fees follow the settings above.</p>
    @if (category === 'New') {
      <div class="mathbox-preview__adjustment" role="group" aria-label="Preview dealer adjustment">
        <button type="button" [attr.aria-pressed]="mathboxPreviewAdjustment === 'addOn'"
                (click)="mathboxPreviewAdjustment = 'addOn'">Dealer Add-On</button>
        <button type="button" [attr.aria-pressed]="mathboxPreviewAdjustment === 'discount'"
                (click)="mathboxPreviewAdjustment = 'discount'">Dealer Discount</button>
      </div>
    }
    <div class="mathbox-preview__canvas">
      <div class="ncs-pricing-breakdown-wrap">
        <div class="ncs-pricing-breakdown">
          <ul>
            @if (category === 'New') {
              <li>MSRP <span>{{ pricing.msrp | currency:'USD':'symbol':'1.0-0' }}</span></li>
              @if (pricing.dealerAdjustment !== 0) {
                <li [class.mathbox-preview__row--dealer-add-on]="pricing.dealerAdjustment > 0"
                    [class.mathbox-preview__row--dealer-discount]="pricing.dealerAdjustment < 0">
                  @if (pricing.dealerAdjustment > 0) {
                    {{ getMathboxPreviewLabel(category, 'dealerAddOnLabel') }}
                  } @else {
                    {{ getMathboxPreviewLabel(category, 'dealerDiscountLabel') }}
                  }
                  <span>@if (pricing.dealerAdjustment > 0) {+} @else {-}{{ pricing.dealerAdjustmentAmount | currency:'USD':'symbol':'1.0-0' }}</span>
                </li>
              }
              @for (fee of getMathboxPreviewFeesAtPosition(category, fees, abovePurchaseSubtotal); track $index) {
                <li class="dt-plus-rebate">{{ fee.label }} <span class="dt-rebate-price">{{ fee.amount | currency:'USD':'symbol':'1.0-0' }}</span></li>
              }
              @if (showMathboxPreviewSubtotal(category, fees, pricing)) {
                <li class="dt-total-rebate subtotal-line-item mathbox-preview__row--subtotal"
                    [style.font-size.px]="getMathboxPreviewFontSize(category, 'priceSubtotalFontSize')"
                    [style.font-weight]="getMathboxPreviewFontWeight(category, 'priceSubtotalBold')">
                  {{ getMathboxPreviewLabel(category, 'priceSubtotalLabel') }}
                  <span [style.font-size.px]="getMathboxPreviewFontSize(category, 'priceSubtotalValueFontSize')"
                        [style.font-weight]="getMathboxPreviewFontWeight(category, 'priceSubtotalBold')">
                    {{ pricing.subtotal | currency:'USD':'symbol':'1.0-0' }}
                  </span>
                </li>
              }
              <li class="dt-minus-rebate">Customer Cash <span class="dt-rebate-price">{{ pricing.rebate | currency:'USD':'symbol':'1.0-0' }}</span></li>
            } @else if (fees.length > 0) {
              <li>Sale Price <span>{{ pricing.subtotal | currency:'USD':'symbol':'1.0-0' }}</span></li>
            }
            @for (fee of getMathboxPreviewFeesAtPosition(category, fees, belowPurchaseSubtotal); track $index) {
              <li class="dt-plus-rebate">{{ fee.label }} <span class="dt-rebate-price">{{ fee.amount | currency:'USD':'symbol':'1.0-0' }}</span></li>
            }
            <li class="dt-total-rebate mathbox-preview__row--final-price"
                [style.font-size.px]="getMathboxPreviewFontSize(category, 'finalPriceFontSize')"
                [style.font-weight]="getMathboxPreviewFontWeight(category, 'finalPriceBold')">
              {{ getMathboxPreviewLabel(category, 'finalPriceText') }}
              <span [style.font-size.px]="getMathboxPreviewFontSize(category, 'finalPriceValueFontSize')"
                    [style.font-weight]="getMathboxPreviewFontWeight(category, 'finalPriceBold')">
                {{ pricing.finalPrice | currency:'USD':'symbol':'1.0-0' }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <p class="mathbox-preview__note">
      Sample vehicle prices and rebates; your current purchase fees. Percentage fees use the sample MSRP
      ({{ pricing.msrp | currency:'USD':'symbol':'1.0-0' }}). Actual vehicle offers will vary.
    </p>
  </div>
</ng-template>
